// @ vendor
const { APIGet } = require('utilities/APIRequestHelper');

// @ commons
const apiURLBuilder = require('core/apiURLBuilder');

const { getFormattedLanguage } = require('commonsUtilities/languageHelper');

// @ constants
const actionTypes = require('constants/contactCenter/actionTypes');
const { BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER } = require('constants/index');

const morningstarSecurityDetailsRequestStart = fundSecId => ({
    type: actionTypes.FUND_LEGAL_CONFIRMATION_MORNINGSTAR_SECURITY_DETAILS_REQUEST_START,
    payload: {
        fundSecId
    }
});

const morningstarSecurityDetailsRequestSuccess = response => ({
    type: actionTypes.FUND_LEGAL_CONFIRMATION_MORNINGSTAR_SECURITY_DETAILS_REQUEST_SUCCESS,
    payload: !!response && !!response[0] ? {0: response[0]} : {},
});

const morningstarSecurityDetailsRequestError = (fundSecId, error) => ({
    type: actionTypes.FUND_LEGAL_CONFIRMATION_MORNINGSTAR_SECURITY_DETAILS_REQUEST_ERROR,
    payload: {
        fundSecId,
        error
    }
});

const reset = () => ({
    type: actionTypes.FUND_LEGAL_CONFIRMATION_RESET
});

const fetchFundMorningstarSecurityDetails = fundSecId => dispatch => {
    dispatch(morningstarSecurityDetailsRequestStart(fundSecId));

    const requestData = {
        query: {
            viewId: 'fullNew',
            languageId: getFormattedLanguage(__CONTACT_CENTER__),
            responseViewFormat: 'json'
        }
    };

    return APIGet(dispatch, apiURLBuilder.getURL('brokerGetMorningStarScreenerSecurityDetails', { type: BROKER_INVESTMENT_FUNDS_PRODUCT_URL_PARAMETER, id: fundSecId }), requestData)
        .then(response => dispatch(morningstarSecurityDetailsRequestSuccess(response)))
        .catch(response => {
            if (response.error) {
                dispatch(morningstarSecurityDetailsRequestError(fundSecId, response.error));
            } else {
                throw response;
            }
        });
};

module.exports = {
    fetchFundMorningstarSecurityDetails,
    reset
};
